import React from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'react-bootstrap'

export const SearchBySucursal = (props) => {

    const {
        handleInputChange
    } = props;

    const { sucursales, checkingSucursales } = useSelector(state => state.empleado);
    const { loadingSucursal } = useSelector(state => state.ui);

    if (loadingSucursal) {
        return (
            <Form.Select aria-label="Default select example"
                name="buscar"
                defaultValue="0"
            >
                <option value="0" disabled>SELECCIONE CARGO:</option>
                <option value="0" disabled>Cargando departamentos...</option>
            </Form.Select>
        )
    }    

    return (
        <Form.Select
            name="buscar"
            onChange={handleInputChange}
            defaultValue="0"
        >
            <option value="0" disabled>SELECCIONE SUCURSAL:    </option>
            {!checkingSucursales
                && (
                    sucursales?.map(({ SUCURSAL }, index) => (
                        <option
                            key={index}
                            value={SUCURSAL}
                        >
                            {SUCURSAL}
                        </option>
                    ))
                )}
        </Form.Select>
    )
}
